<template>
  <div class="or-spacer relative h-8 md:w-1/2 w-10/12">
    <div
      class="after:block after:h-7 after:-mt-7 after:mx-auto after:mb-0 after:w-full mask h-8 overflow-hidden"
    ></div>
    <span
      class="or-spacer-span absolute h-20 w-20 md:w-24 md:h-24 bottom-full left-1/2 rounded-full bg-white md:-mb-12 -mb-10 -ml-10"
    >
      <i
        class="absolute rounded-full border-dashed border border-yellow-600 text-center not-italic font-bold flex items-center justify-center inset-1"
      >
        <span class="md:text-md text-sm uppercase text-pink-800"><slot></slot></span>
      </i>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Divider-component',
});
</script>

<style lang="scss" scoped>
.or-spacer .mask::after {
  border-radius: 125px / 12px;
  box-shadow: 0 0 8px #9d174d;
}

.or-spacer .or-spacer-span {
  box-shadow: 0 2px 4px #999;
}
</style>
